import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Button } from 'src/components/core';

interface ErrorBoundaryProps {
    loading?: boolean;
    hasError: boolean;
    retryAction: () => void;
    children?: React.ReactNode;
}

export const ErrorBoundary = ({ loading, hasError, retryAction, children }: ErrorBoundaryProps) => {
    const { t } = useTranslation();
    const { colors } = useTheme();

    if (hasError) {
        return (
            <Button
                loading={loading}
                size="small"
                variant="text"
                color={colors.primary}
                onClick={retryAction}
            >
                {t('reload')}
            </Button>
        );
    } else if (children) {
        return <>{children}</>;
    }
};
